(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ln-about-scroll')) {
    customElements.define('ln-about-scroll', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.stopScroll();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('click', (event) => {
          const link = event.target.closest('.ln-about__scroll a');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const target = this.querySelector(link.hash);
          if (!target) return;
          event.preventDefault();
          this.stopScroll();
          const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
          const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
          const start = scrollY;
          const end = start + target.getBoundingClientRect().top - padding - margin;
          const started = performance.now();
          const tick = (time) => {
            const progress = Math.min(1, (time - started) / 1600);
            scrollTo({ top: start + (end - start) * progress * progress * (3 - 2 * progress), behavior: 'instant' });
            if (progress < 1) this.frame = requestAnimationFrame(tick);
            else {
              this.frame = null;
              if (location.hash !== link.hash) history.pushState(null, '', link.hash);
              target.focus({ preventScroll: true });
            }
          };
          this.frame = requestAnimationFrame(tick);
        }, options);
        // Only the visitor's own input stops the scroll. Phones fire resize while the address bar collapses
        // mid-scroll, which used to stop it halfway.
        for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
          window.addEventListener(type, () => this.stopScroll(), { ...options, passive: true });
        }
      }
      stopScroll() { cancelAnimationFrame(this.frame); this.frame = null; }
      disconnectedCallback() { this.abort?.abort(); this.stopScroll(); }
    });
  }
  if (!customElements.get('ln-about-message')) {
    customElements.define('ln-about-message', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.classList.add('is-motion-ready');
        this.classList.remove('is-visible');
        this.observer = new IntersectionObserver((entries, observer) => {
          if (!entries.some(entry => entry.intersectionRatio >= .4)) return;
          this.classList.add('is-visible');
          observer.disconnect();
        }, { threshold: .4 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.classList.remove('is-motion-ready', 'is-visible');
      }
    });
  }
  if (!customElements.get('ln-about-carousel')) {
    customElements.define('ln-about-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-about-track]');
        this.slides = Array.from(this.querySelectorAll('[data-about-slide]'));
        this.label = this.querySelector('[data-about-current]');
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;
        this.querySelector('[data-about-controls]').hidden = false;
        this.querySelector('[data-about-prev]').addEventListener('click', () => this.show(this.current - 1), options);
        this.querySelector('[data-about-next]').addEventListener('click', () => this.show(this.current + 1), options);
        this.track.addEventListener('keydown', (event) => {
          const indexes = { ArrowLeft: this.current - 1, ArrowRight: this.current + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in indexes)) return;
          event.preventDefault();
          this.show(indexes[event.key]);
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            this.current = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
            this.update();
          });
        }, { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.show(this.current, true));
        this.resize.observe(this.track);
        this.update();
      }
      show(index, instant = false) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.update();
      }
      update() {
        if (this.label) this.label.textContent = String(this.current + 1).padStart(2, '0');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  if (!customElements.get('ln-about-info')) {
    customElements.define('ln-about-info', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const openLinkedInfo = () => {
          if (window.location.hash !== '#shop-info') return;
          const details = this.querySelector('details');
          details.open = true;
          details.scrollIntoView({ block: 'start' });
        };
        window.addEventListener('hashchange', openLinkedInfo, { signal: this.abort.signal });
        openLinkedInfo();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-commerce-cart]');if(!root)return;
    var itemCount=Number(root.dataset.cartCount||0);
    var cartToken=root.dataset.cartToken||'';
    if(!itemCount||!cartToken)return;
    function record(eventType){fetch('/apps/ln-rental/member/commerce/activity',{method:'POST',cache:'no-store',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({eventType:eventType,referenceKey:cartToken,details:{itemCount:itemCount,cartUrl:window.location.origin+root.dataset.cartUrl}})}).catch(function(){})}
    record('cart_updated');
    var checkout=document.querySelector('[name="checkout"]');
    if(checkout)checkout.addEventListener('click',function(){record('checkout_started')});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function(){
    var root = document.querySelector('.specimens--shop');
    if (!root) return;
    var filtersTop = document.getElementById('filtersTop');
    var filtersSub = document.getElementById('filtersSub');
    var filterBlock = document.getElementById('filterBlock');
    var grid = document.getElementById('specGrid');
    if (!filtersTop || !grid) return;
    var header = document.getElementById('siteHeader');
    function updateFilterOffset() {
      root.style.setProperty('--shop-header-height', (header ? header.offsetHeight : 0) + 'px');
    }
    updateFilterOffset();
    if (header) new ResizeObserver(updateFilterOffset).observe(header);
    var tabLimit = parseInt(root.dataset.tabLimit || '0', 10);
    var tabFooter = root.querySelector('[data-tab-footer]');
    var tabStatus = root.querySelector('[data-tab-status]');
    var tabPagination = root.querySelector('[data-tab-pagination]');
    var activePages = {};
    var sortSelect = root.querySelector('[data-price-order]');
    var sortStatus = root.querySelector('[data-sort-status]');
    var sortMessage = root.querySelector('[data-sort-message]');
    var sortRetry = root.querySelector('[data-sort-retry]');
    var standardCards = Array.from(grid.querySelectorAll('.g-card'));
    var emptyMessage = grid.querySelector('.spec-empty');
    var catalogComplete = false;
    var catalogLoading = false;
    var activeOrder = '';
    var requestedOrder = '';
    var catalogMeta = root.querySelector('[data-catalog-page]');
    var catalogPageParam = catalogMeta ? catalogMeta.dataset.pageParam : 'page';
    var initialCatalogPage = null;
    try { initialCatalogPage = readCatalogPage(root); } catch (error) {}
    var transitionTimer = null;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function favoriteItems(){if(window.LNWishlist)return window.LNWishlist.read();try{return JSON.parse(localStorage.getItem('ln_wishlist_v1')||'[]')}catch(e){return[]}}
    function syncFavoriteButtons(){var items=favoriteItems();root.querySelectorAll('[data-shop-favorite-toggle]').forEach(function(button){var active=items.some(function(item){return item.handle===button.dataset.handle});button.classList.toggle('is-saved',active);button.setAttribute('aria-pressed',active?'true':'false');button.setAttribute('aria-label',active?button.dataset.labelRemove:button.dataset.labelAdd)})}
    root.addEventListener('click',function(event){var button=event.target.closest('[data-shop-favorite-toggle]');if(!button||!root.contains(button))return;event.preventDefault();event.stopPropagation();dispatchEvent(new CustomEvent('ln:wishlist-request',{detail:{handle:button.dataset.handle,productId:button.dataset.productId,title:button.dataset.title,url:button.dataset.url,image:button.dataset.image,category:button.dataset.category,availability:button.dataset.availability,inventoryQuantity:Number(button.dataset.inventoryQuantity||0),notifyRestock:true}}));setTimeout(syncFavoriteButtons,0)});
    addEventListener('ln:wishlist-changed',syncFavoriteButtons);syncFavoriteButtons();

    function installImageFallbacks() {
      Array.from(grid.querySelectorAll('.g-card .frame')).forEach(function(frame){
        var imgs = Array.from(frame.querySelectorAll('img'));
        if (!imgs.length) return;
        function showFallback(img) {
          img.hidden = true;
          if (imgs.every(function(item){ return item.hidden || (item.complete && item.naturalWidth === 0); }) && !frame.querySelector('.no-image')) {
            var fallback = document.createElement('div');
            fallback.className = 'no-image';
            fallback.innerHTML = '<span>NO IMAGE</span>';
            frame.insertBefore(fallback, frame.firstChild);
          }
        }
        imgs.forEach(function(img){
          img.addEventListener('error', function(){ showFallback(img); });
          if (img.complete && img.naturalWidth === 0) showFallback(img);
        });
      });
    }
    installImageFallbacks();
    window.setTimeout(installImageFallbacks, 600);
    window.setTimeout(installImageFallbacks, 1800);

    var SUBS = {};

    var categoryOptions = root.querySelector('[data-category-options]');
    if (categoryOptions) {
      SUBS = {};
      Array.from(categoryOptions.querySelectorAll('[data-sub]')).forEach(function(option){
        var key = option.dataset.top;
        if (!SUBS[key]) SUBS[key] = [];
        SUBS[key].push({k: option.dataset.sub, legacy: option.dataset.legacy, label: option.textContent.trim()});
      });
    }

    var layoutKey = 'ln_layout_v1';
    var saved = localStorage.getItem(layoutKey);
    if (saved === 'large' || saved === 'medium') {
      root.setAttribute('data-layout', saved);
    } else if (saved === 'compact') {
      localStorage.setItem(layoutKey, 'medium');
      root.setAttribute('data-layout', 'medium');
    }

    var activeTop = 'all';
    var activeSub = 'all';

    function compareCards(a, b, order) {
      var original = Number(a.dataset.standardOrder) - Number(b.dataset.standardOrder);
      // No price order is 新着順: the most recently published product first, ties in catalog order.
      if (!order) return (Number(b.dataset.published) || 0) - (Number(a.dataset.published) || 0) || original;
      var aPrice = Number(a.dataset.price), bPrice = Number(b.dataset.price);
      if ((aPrice <= 0) !== (bPrice <= 0)) return aPrice <= 0 ? 1 : -1;
      if (aPrice <= 0 || aPrice === bPrice) return original;
      return order === 'asc' ? aPrice - bPrice : bPrice - aPrice;
    }

    function readCatalogPage(container) {
      var meta = container.querySelector('[data-catalog-page]');
      if (!meta) throw new Error('Missing catalog page');
      function integer(value) {
        if (!/^\d+$/.test(value || '')) throw new Error('Invalid catalog number');
        var number = Number(value);
        if (!Number.isSafeInteger(number)) throw new Error('Invalid catalog number');
        return number;
      }
      var data = meta.dataset;
      var page = {
        total: integer(data.total), page: integer(data.page), pages: Math.max(1, integer(data.pages)),
        pageSize: integer(data.pageSize), sourceCount: integer(data.sourceCount), excludedCount: integer(data.excludedCount),
        pageParam: data.pageParam, sortBy: data.sortBy, collectionHandle: data.collectionHandle,
        cards: Array.from(container.querySelectorAll('.g-card'))
      };
      var offset = (page.page - 1) * page.pageSize;
      if (page.total > 25000 || page.pageSize !== 250 || page.page < 1 || page.page > page.pages || page.pages !== Math.max(1, Math.ceil(page.total / page.pageSize)) || !/^page(?:_\w+)?$/.test(page.pageParam || '') || page.collectionHandle !== root.dataset.collectionHandle || page.sortBy !== root.dataset.defaultSort || page.sourceCount !== Math.min(page.pageSize, Math.max(0, page.total - offset)) || page.excludedCount > 1 || page.cards.length + page.excludedCount !== page.sourceCount) throw new Error('Incomplete catalog page');
      var handles = new Set(), lastOrder = offset - 1;
      page.cards.forEach(function(card){
        var handle = card.dataset.productHandle, order = integer(card.dataset.standardOrder);
        var price = card.dataset.price;
        if (!handle || handle === 'life-nostalgia-gallery' || handles.has(handle) || order <= lastOrder || order >= offset + page.sourceCount || !/^-?\d+$/.test(price || '') || !Number.isSafeInteger(Number(price))) throw new Error('Invalid catalog card');
        handles.add(handle);
        lastOrder = order;
      });
      return page;
    }

    async function fetchCatalogPage(pageNumber) {
      var url = new URL(window.location.href);
      ['price_order', 'view_page', 'category', 'subcategory', 'sort_by', 'sections', 'section_id'].forEach(function(key){ url.searchParams.delete(key); });
      url.searchParams.set(catalogPageParam, String(pageNumber));
      url.searchParams.set('sections', root.dataset.sectionId);
      url.hash = '';
      var controller = new AbortController();
      var timeout = window.setTimeout(function(){ controller.abort(); }, 15000);
      try {
        var response = await fetch(url.pathname + url.search, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Catalog request failed');
        var sections = await response.json();
        var html = sections && sections[root.dataset.sectionId];
        if (typeof html !== 'string' || !html.trim()) throw new Error('Missing catalog section');
        return readCatalogPage(new DOMParser().parseFromString(html, 'text/html'));
      } finally {
        window.clearTimeout(timeout);
      }
    }

    function setCatalogStatus(state) {
      sortSelect.disabled = !catalogComplete || catalogLoading;
      sortSelect.value = activeOrder;
      sortStatus.hidden = !state;
      sortMessage.textContent = state === 'loading' ? root.dataset.sortLoading : state === 'error' ? root.dataset.sortError : '';
      sortRetry.hidden = state !== 'error';
    }

    async function ensureCatalog() {
      if (catalogLoading || catalogComplete) return catalogComplete;
      catalogLoading = true;
      setCatalogStatus('loading');
      try {
        var first = initialCatalogPage;
        var fetched = !first || first.page !== 1;
        if (fetched) first = await fetchCatalogPage(1);
        if (first.page !== 1) throw new Error('Missing first catalog page');
        var cards = [], handles = new Set(), sourceCount = 0, excludedCount = 0;
        for (var pageNumber = 1; pageNumber <= first.pages; pageNumber += 1) {
          var page = pageNumber === 1 ? first : await fetchCatalogPage(pageNumber);
          if (pageNumber > 1) fetched = true;
          if (page.page !== pageNumber || page.total !== first.total || page.pages !== first.pages || page.pageParam !== first.pageParam) throw new Error('Catalog changed during loading');
          sourceCount += page.sourceCount;
          excludedCount += page.excludedCount;
          page.cards.forEach(function(card){
            if (handles.has(card.dataset.productHandle)) throw new Error('Duplicate catalog product');
            handles.add(card.dataset.productHandle);
            cards.push(card);
          });
        }
        if (sourceCount !== first.total || excludedCount > 1 || cards.length !== first.total - excludedCount) throw new Error('Incomplete catalog');
        if (fetched) {
          var fragment = document.createDocumentFragment();
          cards.forEach(function(card){ fragment.appendChild(card); });
          grid.replaceChildren(fragment);
          if (!cards.length && emptyMessage) grid.appendChild(emptyMessage);
        }
        standardCards = cards;
        catalogComplete = true;
        updateCounts();
        installImageFallbacks();
        syncFavoriteButtons();
        restoreViewState();
        syncUrl('replace');
      } catch (error) {
        catalogComplete = false;
      } finally {
        catalogLoading = false;
        setCatalogStatus(catalogComplete ? '' : 'error');
      }
      return catalogComplete;
    }

    function restoreViewState() {
      var params = new URLSearchParams(window.location.search);
      var category = (params.get('category') || 'all').toLowerCase();
      var categories = Array.from(filtersTop.querySelectorAll('[data-top]')).map(function(button){ return button.dataset.top; });
      activeTop = categories.indexOf(category) !== -1 || category === 'all' ? category : 'all';
      activeSub = 'all';
      var subcategory = (params.get('subcategory') || '').toLowerCase();
      if (SUBS[activeTop] && subcategory) {
        var sub = SUBS[activeTop].find(function(option){ return option.k === subcategory || option.legacy === subcategory; });
        if (sub) activeSub = sub.k;
      }
      var order = params.get('price_order');
      requestedOrder = order === 'asc' || order === 'desc' ? order : '';
      activeOrder = catalogComplete ? requestedOrder : '';
      sortSelect.value = activeOrder;
      var page = params.get('view_page') || '1';
      activePages[activeKey()] = /^\d+$/.test(page) && Number.isSafeInteger(Number(page)) ? Math.max(1, Number(page)) : 1;
      Array.from(filtersTop.querySelectorAll('.chip[data-top]')).forEach(function(chip){ chip.classList.toggle('active', chip.dataset.top === activeTop); });
      if (activeTop !== 'all' && SUBS[activeTop]) showSubs(activeTop);
      else hideSubs();
      applyFilter();
      updateCollectionLinks();
    }

    function activeKey() {
      return activeTop + ':' + activeSub + ':' + activeOrder;
    }

    function syncUrl(mode) {
      var url = new URL(window.location.href);
      if (activeTop === 'all') {
        url.searchParams.delete('category');
        url.searchParams.delete('subcategory');
      } else {
        url.searchParams.set('category', activeTop);
        if (activeSub === 'all') url.searchParams.delete('subcategory');
        else url.searchParams.set('subcategory', activeSub);
      }
      if (requestedOrder) url.searchParams.set('price_order', requestedOrder);
      else url.searchParams.delete('price_order');
      if (currentPage() > 1) url.searchParams.set('view_page', String(currentPage()));
      else url.searchParams.delete('view_page');
      url.searchParams.delete('sort_by');
      url.searchParams.delete(catalogPageParam);
      var next = url.pathname + url.search + url.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', next);
      updateCollectionLinks();
    }

    function updateCollectionLinks() {
      root.querySelectorAll('[data-collection-link]').forEach(function(link){
        if (!link.dataset.collectionBase) link.dataset.collectionBase = link.href;
        var url = new URL(link.dataset.collectionBase, window.location.origin);
        var current = new URL(window.location.href);
        current.searchParams.forEach(function(value, key){ if (['sort_by', catalogPageParam, 'view_page', 'sections', 'section_id'].indexOf(key) === -1) url.searchParams.set(key, value); });
        ['category', 'subcategory', 'price_order'].forEach(function(key){ url.searchParams.delete(key); });
        if (activeTop !== 'all') url.searchParams.set('category', activeTop);
        if (activeTop !== 'all' && activeSub !== 'all') url.searchParams.set('subcategory', activeSub);
        if (requestedOrder) url.searchParams.set('price_order', requestedOrder);
        url.searchParams.delete('view_page');
        url.searchParams.delete('sort_by');
        url.searchParams.delete(catalogPageParam);
        link.href = url.pathname + url.search;
      });
    }

    function resetActivePage() {
      if (!tabLimit) return;
      activePages[activeKey()] = 1;
    }

    function currentPage() {
      if (!tabLimit) return 1;
      if (!activePages[activeKey()]) activePages[activeKey()] = 1;
      return activePages[activeKey()];
    }

    function updateCounts() {
      if (!catalogComplete) {
        filtersTop.querySelectorAll('[data-count]').forEach(function(count){ count.textContent = '—'; });
        return;
      }
      var counts = { all: 0 };
      Array.from(filtersTop.querySelectorAll('[data-top]')).forEach(function(chip){ counts[chip.dataset.top] = 0; });
      Array.from(grid.children).forEach(function(card){
        if (!card.classList || !card.classList.contains('g-card')) return;
        counts.all++;
        (card.dataset.tops || '').split(/\s+/).forEach(function(key){ if (key && key !== 'all' && Object.hasOwn(counts, key)) counts[key]++; });
      });
      Array.from(filtersTop.querySelectorAll('.chip')).forEach(function(c){
        var k = c.dataset.top;
        if (!k) return;
        var n = counts[k] || 0;
        var span = c.querySelector('[data-count]');
        if (span) span.textContent = n;
        if (k !== 'all') c.classList.toggle('disabled', n === 0);
      });
    }
    updateCounts();

    function scrollToProductTop() {
      var offset = header ? header.offsetHeight + 12 : 0;
      var target = filterBlock ? filterBlock.parentElement : root;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }

    function applyFilter(options) {
      options = options || {};
      window.clearTimeout(transitionTimer);
      if (options.scroll) scrollToProductTop();
      if (options.animate && !prefersReducedMotion) {
        grid.classList.add('is-transitioning');
        transitionTimer = window.setTimeout(function(){
          renderFilter();
          grid.classList.remove('is-transitioning');
        }, 180);
        return;
      }
      grid.classList.remove('is-transitioning');
      renderFilter();
    }

    function renderFilter() {
      var cards = standardCards;
      var matchedCards = [];
      cards.forEach(function(card){
        if (!card.classList || !card.classList.contains('g-card')) return;
        var ct = (card.dataset.tops || '').split(/\s+/);
        var cs = (card.dataset.subs || '').split(/\s+/);
        var show = true;
        if (activeTop !== 'all') {
          show = ct.indexOf(activeTop) !== -1;
          if (show && activeSub !== 'all') show = cs.indexOf(activeSub) !== -1;
        }
        if (show) matchedCards.push(card);
      });
      if (catalogComplete) matchedCards.sort(function(a, b){ return compareCards(a, b, activeOrder); });
      var matchedSet = new Set(matchedCards);
      var fragment = document.createDocumentFragment();
      matchedCards.concat(cards.filter(function(card){ return !matchedSet.has(card); })).forEach(function(card){ fragment.appendChild(card); });
      grid.appendChild(fragment);

      var matched = matchedCards.length;
      var pageSize = tabLimit || matched;
      var totalPages = pageSize ? Math.max(1, Math.ceil(matched / pageSize)) : 1;
      var page = currentPage();
      if (page > totalPages) {
        page = totalPages;
        if (catalogComplete) activePages[activeKey()] = page;
      }
      var start = tabLimit ? (page - 1) * pageSize : 0;
      var end = tabLimit ? start + pageSize : matched;
      var shown = 0;
      var visible = new Set(matchedCards.slice(start, end));
      cards.forEach(function(card){
        var show = visible.has(card);
        card.classList.toggle('hidden', !show);
        if (show) shown += 1;
      });
      updateTabFooter(matched, shown, page, totalPages, start);
      document.dispatchEvent(new CustomEvent('ln:content-update', { detail: { root: grid } }));
    }

    function updateTabFooter(matched, shown, page, totalPages, start) {
      if (!tabFooter || !tabStatus) return;
      tabFooter.hidden = matched === 0 || !catalogComplete;
      var rangeStart = matched ? start + 1 : 0;
      var rangeEnd = matched ? start + shown : 0;
      tabStatus.textContent = rangeStart + '-' + rangeEnd + ' / ' + matched + ' shown';
      renderPagination(page, totalPages);
    }

    function renderPagination(page, totalPages) {
      if (!tabPagination) return;
      if (totalPages <= 1) {
        tabPagination.hidden = true;
        tabPagination.innerHTML = '';
        return;
      }
      tabPagination.hidden = false;
      var html = '<button type="button" data-page="' + (page - 1) + '"' + (page <= 1 ? ' disabled' : '') + '>PREV</button>';
      for (var i = 1; i <= totalPages; i += 1) {
        html += '<button type="button" data-page="' + i + '"' + (i === page ? ' class="is-active" aria-current="page"' : '') + '>' + i + '</button>';
      }
      html += '<button type="button" data-page="' + (page + 1) + '"' + (page >= totalPages ? ' disabled' : '') + '>NEXT</button>';
      tabPagination.innerHTML = html;
    }

    restoreViewState();
    if (sortSelect) sortSelect.addEventListener('change', function(){
      if (!catalogComplete) return;
      requestedOrder = sortSelect.value === 'asc' || sortSelect.value === 'desc' ? sortSelect.value : '';
      activeOrder = requestedOrder;
      resetActivePage();
      syncUrl();
      applyFilter({ scroll: true });
    });
    sortRetry.addEventListener('click', function(){ ensureCatalog(); });
    window.addEventListener('popstate', function(){ restoreViewState(); if (catalogComplete) syncUrl('replace'); });

    filtersTop.addEventListener('click', function(e){
      var b = e.target.closest('.chip');
      if (!b || !b.dataset.top || b.classList.contains('disabled')) return;
      activeTop = b.dataset.top;
      activeSub = 'all';
      resetActivePage();
      syncUrl();
      Array.from(filtersTop.querySelectorAll('.chip[data-top]')).forEach(function(c){ c.classList.toggle('active', c.dataset.top === activeTop); });
      applyFilter({ animate: true, scroll: true });
      if (SUBS[activeTop]) {
        showSubs(activeTop);
      } else {
        hideSubs();
      }
    });

    filtersTop.addEventListener('mouseover', function(e){
      var b = e.target.closest('.chip');
      if (!b || !b.dataset.top || b.classList.contains('disabled')) return;
      showSubs(b.dataset.top);
    });
    filterBlock.addEventListener('mouseleave', hideSubs);

    function showSubs(topKey){
      var subs = SUBS[topKey];
      if (!subs) { hideSubs(); return; }
      filtersSub.replaceChildren();
      subs.forEach(function(s, i){
        if (i) {
          var divider = document.createElement('span');
          divider.className = 'divider';
          divider.textContent = '/';
          filtersSub.appendChild(divider);
        }
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'chip' + (topKey === activeTop && s.k === activeSub ? ' active' : '');
        chip.dataset.top = topKey;
        chip.dataset.sub = s.k;
        chip.textContent = s.label;
        filtersSub.appendChild(chip);
      });
      filtersSub.classList.add('open');
    }
    function hideSubs(){ filtersSub.classList.remove('open'); }

    document.addEventListener('click', function(e){
      var b = e.target.closest('#filtersSub .chip');
      if (!b || !b.dataset.top || b.classList.contains('disabled')) return;
      activeTop = b.dataset.top;
      activeSub = b.dataset.sub;
      resetActivePage();
      syncUrl();
      Array.from(filtersTop.querySelectorAll('.chip[data-top]')).forEach(function(c){ c.classList.toggle('active', c.dataset.top === activeTop); });
      applyFilter({ animate: true, scroll: true });
      showSubs(activeTop);
    });

    if (tabPagination) {
      tabPagination.addEventListener('click', function(e){
        var button = e.target.closest('button[data-page]');
        if (!button || button.disabled) return;
        var page = parseInt(button.dataset.page || '1', 10);
        activePages[activeKey()] = Math.max(1, page);
        applyFilter({ animate: true, scroll: true });
        syncUrl();
      });
    }

    var switchGroup = root.querySelector('.spec-layout-switch');
    if (switchGroup) {
      switchGroup.addEventListener('click', function(e){
        var b = e.target.closest('button');
        if (!b) return;
        var key = b.dataset.layout;
        root.setAttribute('data-layout', key);
        localStorage.setItem(layoutKey, key);
        Array.from(switchGroup.children).forEach(function(c){ c.classList.toggle('active', c.dataset.layout === key); });
      });
      Array.from(switchGroup.children).forEach(function(c){ c.classList.toggle('active', c.dataset.layout === root.getAttribute('data-layout')); });
    }
    ensureCatalog();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  if (!customElements.get('ln-contact-form')) {
    customElements.define('ln-contact-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const other = this.querySelector('[data-contact-other]');
        const field = this.querySelector('[data-contact-other-field]');
        const input = field?.querySelector('input');
        const order = this.querySelector('[data-contact-order]');
        const orderField = this.querySelector('[data-contact-order-field]');
        const orderInput = orderField?.querySelector('input');
        if (!form || !other || !input || !order || !orderInput) return;
        const topic = new URLSearchParams(window.location.search).get('topic');
        const preset = topic === 'product' ? this.querySelector('[data-contact-product]')
          : topic === 'membership' ? this.querySelector('[data-contact-membership]') : null;
        if (preset && !form.querySelector('input[name="contact[お問合せ項目]"]:checked')) {
          preset.checked = true;
        }
        const sync = () => {
          field.hidden = !other.checked;
          input.disabled = !other.checked;
          input.required = other.checked;
          orderField.hidden = !order.checked;
          orderInput.disabled = !order.checked;
          form.querySelectorAll('input[type="text"], textarea').forEach(control => {
            control.setCustomValidity(control.required && !control.value.trim() ? this.dataset.requiredMessage : '');
          });
        };
        form.addEventListener('change', sync);
        form.addEventListener('input', sync);
        form.addEventListener('submit', event => {
          sync();
          if (!form.reportValidity()) event.preventDefault();
        });
        window.addEventListener('pageshow', sync);
        sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function(){var button=document.querySelector('[data-back-to-top]');var footer=document.querySelector('footer.site-footer');if(!button)return;function update(){var beforeFooter=!footer||footer.getBoundingClientRect().top>innerHeight;button.classList.toggle('is-visible',scrollY>innerHeight*.8&&beforeFooter)}update();addEventListener('scroll',update,{passive:true});addEventListener('resize',update);button.addEventListener('click',function(){scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-account"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-account-migration]');
    if (!root || root.dataset.designMode === 'true') return;
    const params = new URLSearchParams(location.search);
    const view = params.get('account_view') || 'orders';
    const destinations = { life: 'orders', orders: 'orders', profile: 'profile', gallery: 'gallery' };
    // Unknown old links keep usable navigation; user input is never a redirect URL.
    if (!Object.hasOwn(destinations, view)) return;
    const anchor = root.querySelector(`[data-destination="${destinations[view]}"]`);
    if (!anchor) return;
    const destination = new URL(anchor.href, location.origin);
    const language = params.get('locale');
    if (destinations[view] !== 'gallery' && ['ja', 'en'].includes(language)) {
      destination.searchParams.set('locale', language);
    }
    if (destination.href !== location.href) location.replace(destination.href);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function(){
    var header=document.getElementById('siteHeader'); if(!header)return;
    var toggle=header.querySelector('[data-mobile-menu-toggle]'), menu=document.getElementById('mobileMenu'), timer;
    function resetMobileSubmenus(){if(!menu)return;menu.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function(button){var panel=document.getElementById(button.getAttribute('aria-controls'));button.setAttribute('aria-expanded','false');if(panel)panel.hidden=true;var marker=button.lastElementChild;if(marker)marker.textContent='＋'})}
    function closeMenu(){if(!toggle||!menu)return;toggle.setAttribute('aria-expanded','false');header.classList.remove('is-menu-open');document.documentElement.classList.remove('mobile-menu-open');resetMobileSubmenus();clearTimeout(timer);timer=setTimeout(function(){menu.hidden=true},360)}
    if(toggle&&menu){toggle.addEventListener('click',function(){var open=toggle.getAttribute('aria-expanded')!=='true';if(!open)return closeMenu();clearTimeout(timer);menu.hidden=false;toggle.setAttribute('aria-expanded','true');document.documentElement.classList.add('mobile-menu-open');requestAnimationFrame(function(){header.classList.add('is-menu-open')})});menu.addEventListener('click',function(e){var submenuToggle=e.target.closest('[data-mobile-submenu-toggle]');if(submenuToggle){var panel=document.getElementById(submenuToggle.getAttribute('aria-controls'));var open=submenuToggle.getAttribute('aria-expanded')!=='true';menu.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function(other){if(other===submenuToggle)return;var otherPanel=document.getElementById(other.getAttribute('aria-controls'));other.setAttribute('aria-expanded','false');if(otherPanel)otherPanel.hidden=true;var otherMarker=other.lastElementChild;if(otherMarker)otherMarker.textContent='＋'});submenuToggle.setAttribute('aria-expanded',open?'true':'false');if(panel)panel.hidden=!open;var marker=submenuToggle.lastElementChild;if(marker)marker.textContent=open?'−':'＋';return}if(e.target.closest('a'))closeMenu()})}
    function scrollState(){header.classList.toggle('is-scrolled',scrollY>12)} scrollState();addEventListener('scroll',scrollState,{passive:true});
    var drawer=document.getElementById('wishlistDrawer'), openers=document.querySelectorAll('[data-wishlist-open]'), itemsRoot=drawer&&drawer.querySelector('[data-wishlist-items]'), empty=drawer&&drawer.querySelector('[data-wishlist-empty]'), key='ln_wishlist_v1';
    function read(){try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}}
    function write(items){try{localStorage.setItem(key,JSON.stringify(items))}catch(e){}render();dispatchEvent(new CustomEvent('ln:wishlist-changed',{detail:items}))}
    function render(){var items=read();document.querySelectorAll('[data-wishlist-count]').forEach(function(c){c.textContent=items.length;c.hidden=!items.length});if(!itemsRoot||!empty)return;itemsRoot.innerHTML='';empty.hidden=!!items.length;items.forEach(function(item){var row=document.createElement('div');row.className='wishlist-item';var a=document.createElement('a');a.className='wishlist-item__image';a.href=item.url;if(item.image){var img=document.createElement('img');img.src=item.image;img.alt='';img.loading='lazy';a.appendChild(img)}var title=document.createElement('a');title.className='wishlist-item__title';title.href=item.url;title.textContent=item.title;var remove=document.createElement('button');remove.type='button';remove.className='wishlist-item__remove';remove.setAttribute('aria-label',drawer.dataset.removeLabel||'Remove');remove.textContent='×';remove.addEventListener('click',function(){write(read().filter(function(x){return x.handle!==item.handle}))});row.append(a,title,remove);itemsRoot.appendChild(row)})}
    function drawerState(open){if(!drawer)return;drawer.classList.toggle('is-open',open);drawer.setAttribute('aria-hidden',open?'false':'true');document.documentElement.classList.toggle('wishlist-open',open);openers.forEach(function(b){b.setAttribute('aria-expanded',open?'true':'false')});if(open)drawer.querySelector('[data-wishlist-close]').focus()}
    openers.forEach(function(b){b.addEventListener('click',function(){drawerState(true)})});if(drawer)drawer.querySelectorAll('[data-wishlist-close]').forEach(function(b){b.addEventListener('click',function(){drawerState(false)})});
    addEventListener('ln:wishlist-request',function(e){var item=e.detail,items=read(),exists=items.some(function(x){return x.handle===item.handle});write(exists?items.filter(function(x){return x.handle!==item.handle}):items.concat(item))});document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMenu();drawerState(false)}});window.LNWishlist={read:read,render:render};render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach(function(root){
    var slides=Array.from(root.querySelectorAll('[data-hero-slide]')),progress=Array.from(root.querySelectorAll('[data-hero-progress]')),current=0,timer,interval=Number(root.dataset.interval)||6000;
    function show(index){current=(index+slides.length)%slides.length;slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===current)});progress.forEach(function(button,i){button.classList.remove('is-active');button.classList.toggle('is-complete',i<current);button.setAttribute('aria-current',i===current?'true':'false')});if(progress[current]){progress[current].style.setProperty('--ln-hero-duration',(interval/1000)+'s');void progress[current].offsetWidth;progress[current].classList.add('is-active')}}
    function stop(){clearInterval(timer)}
    function start(){stop();if(slides.length>1&&root.dataset.autoplay==='true'&&!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(function(){show(current+1)},interval)}
    progress.forEach(function(button,i){button.addEventListener('click',function(){show(i);start()})});var touchX=null;root.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].clientX;stop()},{passive:true});root.addEventListener('touchend',function(e){if(touchX!==null){var delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>45)show(current+(delta<0?1:-1));touchX=null;start()}},{passive:true});root.addEventListener('touchcancel',function(){touchX=null;start()},{passive:true});root.addEventListener('focusin',stop);root.addEventListener('focusout',start);document.addEventListener('visibilitychange',function(){document.hidden?stop():start()});show(0);start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hot-items"] && !Shopify.designMode) return;
  try {
    
  (function(){var buttons=document.querySelectorAll('[data-favorite-toggle]');function saved(){if(window.LNWishlist)return window.LNWishlist.read();try{return JSON.parse(localStorage.getItem('ln_wishlist_v1')||'[]')}catch(e){return[]}}function sync(){var items=saved();buttons.forEach(function(button){var card=button.closest('[data-hot-card]'),active=items.some(function(item){return item.handle===card.dataset.handle});button.classList.toggle('is-saved',active);button.setAttribute('aria-pressed',active?'true':'false');button.setAttribute('aria-label',active?button.dataset.labelRemove:button.dataset.labelAdd)})}buttons.forEach(function(button){button.addEventListener('click',function(){var card=button.closest('[data-hot-card]');dispatchEvent(new CustomEvent('ln:wishlist-request',{detail:{handle:card.dataset.handle,title:button.dataset.title,url:button.dataset.url,image:button.dataset.image}}));setTimeout(sync,0)})});addEventListener('ln:wishlist-changed',sync);sync()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-location-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-location-carousel]').forEach(function(root){
    var slides=Array.from(root.querySelectorAll('[data-location-slide]'));
    var current=0;
    var label=root.querySelector('[data-location-current]');
    var viewport=root.querySelector('[data-location-viewport]');
    var pointerStart=null;

    function show(index){
      current=(index+slides.length)%slides.length;
      slides.forEach(function(slide,slideIndex){
        slide.classList.remove('is-active','is-prev','is-next');
        slide.setAttribute('aria-hidden','true');
        if(slideIndex===current){slide.classList.add('is-active');slide.setAttribute('aria-hidden','false')}
        if(slides.length>2&&slideIndex===(current-1+slides.length)%slides.length){slide.classList.add('is-prev')}
        if(slides.length>1&&slideIndex===(current+1)%slides.length){slide.classList.add('is-next')}
      });
      if(label)label.textContent=String(current+1).padStart(2,'0');
    }

    function move(direction){show(current+direction)}

    if(slides.length>1){
      root.querySelector('[data-location-prev]').addEventListener('click',function(){move(-1)});
      root.querySelector('[data-location-next]').addEventListener('click',function(){move(1)});
      slides.forEach(function(slide){slide.addEventListener('click',function(){if(slide.classList.contains('is-prev'))move(-1);if(slide.classList.contains('is-next'))move(1)})});
      viewport.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}if(event.key==='ArrowRight'){event.preventDefault();move(1)}});
      viewport.addEventListener('pointerdown',function(event){pointerStart=event.clientX});
      viewport.addEventListener('pointerup',function(event){if(pointerStart===null)return;var delta=event.clientX-pointerStart;if(Math.abs(delta)>45)move(delta<0?1:-1);pointerStart=null});
      viewport.addEventListener('pointercancel',function(){pointerStart=null});
    }

    show(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function(){
    var productFavorite = document.querySelector('[data-product-favorite-toggle]');
    function productFavoriteItems(){if(window.LNWishlist)return window.LNWishlist.read();try{return JSON.parse(localStorage.getItem('ln_wishlist_v1')||'[]')}catch(e){return[]}}
    function syncProductFavorite(){if(!productFavorite)return;var active=productFavoriteItems().some(function(item){return item.handle===productFavorite.dataset.handle});productFavorite.classList.toggle('is-saved',active);productFavorite.setAttribute('aria-pressed',active?'true':'false');productFavorite.setAttribute('aria-label',active?productFavorite.dataset.labelRemove:productFavorite.dataset.labelAdd);var label=productFavorite.querySelector('span');if(label)label.textContent=active?productFavorite.dataset.labelRemove:productFavorite.dataset.labelAdd}
    if(productFavorite){productFavorite.addEventListener('click',function(){dispatchEvent(new CustomEvent('ln:wishlist-request',{detail:{handle:productFavorite.dataset.handle,productId:productFavorite.dataset.productId,title:productFavorite.dataset.title,url:productFavorite.dataset.url,image:productFavorite.dataset.image,category:productFavorite.dataset.category,availability:productFavorite.dataset.availability,inventoryQuantity:Number(productFavorite.dataset.inventoryQuantity||0),notifyRestock:true}}));setTimeout(syncProductFavorite,0)});addEventListener('ln:wishlist-changed',syncProductFavorite);syncProductFavorite();fetch('/apps/ln-rental/member/commerce/activity',{method:'POST',cache:'no-store',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({eventType:'product_viewed',referenceKey:productFavorite.dataset.handle,details:{category:productFavorite.dataset.category}})}).catch(function(){})}
    var mainImg = document.getElementById('mainImg');
    var thumbs = document.getElementById('thumbs');
    var galleryMain = mainImg ? mainImg.closest('.d-main') : null;
    var galleryPrev = document.querySelector('[data-gallery-prev]');
    var galleryNext = document.querySelector('[data-gallery-next]');

    if (mainImg && thumbs) {
      var thumbEls = Array.from(thumbs.querySelectorAll('.t'));
      var total = thumbEls.length;
      var idx = 0;
      var displayedIdx = 0;
      var imageRequest = 0;
      var imageAnimation = null;
      var imageOverlay = null;

      async function setImg(i){
        if (!total) return;
        idx = (i + total) % total;
        var request = ++imageRequest;
        if (imageAnimation) imageAnimation.cancel();
        if (imageOverlay) imageOverlay.remove();
        if (idx === displayedIdx) return;
        var t = thumbEls[idx];
        if (!t) return;
        var nextImage = new Image();
        nextImage.sizes = mainImg.sizes;
        nextImage.srcset = t.dataset.mainSrcset || '';
        nextImage.src = t.dataset.mainSrc;
        try {
          await nextImage.decode();
        } catch (error) {
          if (request === imageRequest) idx = displayedIdx;
          return;
        }
        if (request !== imageRequest) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduceMotion && galleryMain) {
          nextImage.className = 'd-main__transition-image';
          nextImage.alt = '';
          nextImage.setAttribute('aria-hidden', 'true');
          galleryMain.appendChild(nextImage);
          imageOverlay = nextImage;
          imageAnimation = nextImage.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-in-out', fill: 'forwards' });
          try { await imageAnimation.finished; } catch (error) { return; }
        }
        if (request !== imageRequest) return;
        mainImg.srcset = t.dataset.mainSrcset || '';
        mainImg.src = t.dataset.mainSrc;
        mainImg.width = nextImage.naturalWidth;
        mainImg.height = nextImage.naturalHeight;
        if (t.dataset.mainAlt) {
          mainImg.alt = t.dataset.mainAlt;
        }
        displayedIdx = idx;
        if (galleryMain) {
          galleryMain.setAttribute('data-active-index', String(idx));
        }
        thumbEls.forEach(function(el, k){
          var selected = k === idx;
          el.classList.toggle('on', selected);
          el.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (imageAnimation) imageAnimation.cancel();
        if (imageOverlay) imageOverlay.remove();
        imageOverlay = null;
      }

      thumbs.addEventListener('click', function(e){
        var t = e.target.closest('.t');
        if (!t) return;
          setImg(Number(t.dataset.i));
      });

      if (galleryPrev) {
        galleryPrev.addEventListener('click', function(){
          setImg(idx - 1);
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener('click', function(){
          setImg(idx + 1);
        });
      }

      if (galleryMain && total > 1) {
        var touchStartX = null;
        var touchStartY = null;

        function resetTouch() {
          touchStartX = null;
          touchStartY = null;
        }

        galleryMain.addEventListener('touchstart', function(event){
          if (event.touches.length !== 1) {
            resetTouch();
            return;
          }
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });

        galleryMain.addEventListener('touchend', function(event){
          if (touchStartX === null || touchStartY === null || event.changedTouches.length !== 1) {
            resetTouch();
            return;
          }
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          var deltaY = event.changedTouches[0].clientY - touchStartY;
          resetTouch();
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
          setImg(idx + (deltaX < 0 ? 1 : -1));
        }, { passive: true });

        galleryMain.addEventListener('touchcancel', resetTouch, { passive: true });
      }
    }

    // Sticky add-to-cart bar: show when main CTA scrolls out of view
    var mainAdd = document.getElementById('mainAdd');
    var bar = document.getElementById('addBar');
    if (mainAdd && bar) {
      function setStickyBarVisible(showing) {
        bar.classList.toggle('on', showing);
        bar.setAttribute('aria-hidden', showing ? 'false' : 'true');
      }

      function updateStickyBar() {
        var rect = mainAdd.getBoundingClientRect();
        setStickyBarVisible(rect.bottom < 96);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          var entry = entries[0];
          var showing = !entry.isIntersecting && entry.boundingClientRect.top < 100;
          setStickyBarVisible(showing);
        }, { rootMargin: '-70px 0px 0px 0px', threshold: 0 });
        io.observe(mainAdd);
      }
      window.addEventListener('scroll', updateStickyBar, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      updateStickyBar();
    }

    if (window.LN_RENTAL_BOOKING_PAGE) {
      document.body.classList.add('ln-rental-booking');
      var rentalPrice = document.querySelector('[data-rental-price]');
      var rentalStickyPrice = document.querySelector('[data-rental-sticky-price]');
      var rentalLabel = document.querySelector('[data-rental-plan-label]');
      var planProperty = document.querySelector('[data-rental-property="plan"]');
      var daysProperty = document.querySelector('[data-rental-property="days"]');
      var setupProperty = document.querySelector('[data-rental-property="setup"]');
      var extensionProperty = document.querySelector('[data-rental-property="extension"]');
      var totalProperty = document.querySelector('[data-rental-property="total"]');

      function applyRentalRequestState() {
        if (rentalPrice) rentalPrice.textContent = 'RESERVATION REQUEST';
        if (rentalStickyPrice) rentalStickyPrice.textContent = 'REQUEST';
        if (rentalLabel) rentalLabel.textContent = 'DATE FIRST';
        if (planProperty) planProperty.value = '日程確認後に確定';
        if (daysProperty) daysProperty.value = '日程確認後に確定';
        if (setupProperty) setupProperty.value = '確認後に確定';
        if (extensionProperty) extensionProperty.value = '確認後に確定';
        if (totalProperty) totalProperty.value = '正式見積もり後にご案内';
      }

      function normalizeRentalContactFields() {
        var roots = Array.from(document.querySelectorAll('.ReactModalPortal, [role="dialog"], #digital_appointments_container, .d-buy__app-block'));
        roots.forEach(function(root){
          Array.from(root.querySelectorAll('input')).forEach(function(input){
            var descriptor = [
              input.getAttribute('type'),
              input.getAttribute('name'),
              input.getAttribute('id'),
              input.getAttribute('placeholder'),
              input.getAttribute('aria-label'),
              input.className
            ].join(' ').toLowerCase();
            var looksLikePhone = input.type === 'tel'
              || descriptor.indexOf('phone') !== -1
              || descriptor.indexOf('tel') !== -1
              || descriptor.indexOf('電話') !== -1;
            if (!looksLikePhone) return;
            input.setAttribute('inputmode', 'tel');
            input.setAttribute('autocomplete', 'tel-national');
            input.removeAttribute('placeholder');
            if ((input.value || '').trim() === '+1') {
              input.value = '';
              input.defaultValue = '';
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            input.style.borderLeft = '1px solid rgb(137, 143, 147)';
            input.style.borderRadius = '.5em';
            input.style.paddingLeft = '.5em';
          });

          Array.from(root.querySelectorAll('select')).forEach(function(select){
            var text = [
              select.getAttribute('name'),
              select.getAttribute('id'),
              select.getAttribute('aria-label'),
              select.className,
              select.closest('label') ? select.closest('label').textContent : ''
            ].join(' ').toLowerCase();
            var looksLikeCountry = text.indexOf('country') !== -1 || text.indexOf('国') !== -1;
            if (!looksLikeCountry) return;
            select.value = 'JP';
            select.setAttribute('aria-hidden', 'true');
            select.tabIndex = -1;
            select.style.display = 'none';
          });

          Array.from(root.querySelectorAll('.iti__flag-container, .iti__country-container, .iti__selected-country, .iti__country-list, .flag-dropdown, .selected-flag, .country-list, .PhoneInputCountry, .PhoneInputCountrySelect, .PhoneInputCountryIcon')).forEach(function(node){
            node.setAttribute('aria-hidden', 'true');
            node.style.display = 'none';
          });
        });
      }

      function normalizeRentalCalendarChrome() {
        var roots = Array.from(document.querySelectorAll('.ReactModalPortal, [role="dialog"], #digital_appointments_container, .d-buy__app-block'));
        roots.forEach(function(root){
          Array.from(root.querySelectorAll('[aria-label="Time format"]')).forEach(function(node){
            node.setAttribute('aria-hidden', 'true');
            node.style.display = 'none';
          });

          Array.from(root.querySelectorAll('button')).forEach(function(button){
            var label = (button.textContent || '').trim();
            if (label === 'AM/PM' || label === '24h') {
              var group = button.closest('[aria-label="Time format"]');
              if (group) {
                group.setAttribute('aria-hidden', 'true');
                group.style.display = 'none';
              } else {
                button.setAttribute('aria-hidden', 'true');
                button.style.display = 'none';
              }
            }
          });

          Array.from(root.querySelectorAll('div')).forEach(function(node){
            var text = (node.textContent || '').trim().replace(/\s+/g, ' ');
            if (/^Timezone:\s*Asia\/Tokyo$/i.test(text)) {
              node.setAttribute('aria-hidden', 'true');
              node.style.display = 'none';
            }
          });
        });
      }

      function isRentalNodeVisible(node) {
        if (!node) return false;
        var style = window.getComputedStyle(node);
        var rect = node.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      }

      applyRentalRequestState();

      function normalizeEabTimeslots() {
        var eabButtons = Array.from(document.querySelectorAll('.servicify-select-a-time-button'));
        var eabStatus = document.querySelector('[data-rental-eab-status]');
        eabButtons.forEach(function(button){
          if ((button.textContent || '').trim() !== '日程を選択する') {
            button.textContent = '日程を選択する';
          }
        });
        if (eabStatus) {
          eabStatus.classList.toggle('is-hidden', eabButtons.length > 0);
        }
        var picker = document.querySelector('[data-servicify="calendar-time-picker"]');
        var description = document.querySelector('[data-servicify="description"]');
        if (description) {
          var rentalDescription = 'まず利用開始日を1日選択してください。利用終了日や連続利用日数、搬入、延長、料金は確認後にご案内します。';
          if (description.textContent !== rentalDescription) {
            description.textContent = rentalDescription;
          }
        }
        normalizeRentalContactFields();
        normalizeRentalCalendarChrome();
        if (!picker) return;
        var timePattern = /^\s*\d{1,2}:\d{2}(?:\s(?:AM|PM))?\s-\s\d{1,2}:\d{2}(?:\s(?:AM|PM))?\s*$/i;
        var timeNodes = Array.from(picker.querySelectorAll('div')).filter(function(node){
          var text = (node.textContent || '').trim();
          if (!timePattern.test(text)) return false;
          return !Array.from(node.children).some(function(child){
            return timePattern.test((child.textContent || '').trim());
          });
        });
        var slotEntries = [];
        timeNodes.forEach(function(node){
          var card = node.parentElement;
          if (card && !slotEntries.some(function(entry){ return entry.card === card; })) {
            slotEntries.push({ card: card, node: node });
          }
        });
        slotEntries.forEach(function(entry, index){
          entry.card.style.display = index === 0 ? '' : 'none';
        });
        var visibleSlotEntries = slotEntries.filter(function(entry){
          return isRentalNodeVisible(entry.card);
        });
        if (visibleSlotEntries.length === 1) {
          var onlySlot = visibleSlotEntries[0].card;
          var onlySlotTarget = visibleSlotEntries[0].node;
          if (!onlySlot.dataset.lnRentalAutoSelected) {
            onlySlot.dataset.lnRentalAutoSelected = 'true';
            onlySlotTarget.click();
          }
          var slotGroup = onlySlot.closest('.servicify-slots-scroll') || onlySlot.parentElement;
          if (slotGroup) {
            slotGroup.setAttribute('aria-hidden', 'true');
            slotGroup.style.display = 'none';
          }
          return;
        }
        slotEntries.forEach(function(entry){
          if ((entry.node.textContent || '').trim() !== 'この日程で進む') {
            entry.node.textContent = 'この日程で進む';
          }
        });
      }

      var normalizeQueued = false;
      function queueNormalizeEabTimeslots() {
        if (normalizeQueued) return;
        normalizeQueued = true;
        window.requestAnimationFrame(function(){
          normalizeQueued = false;
          normalizeEabTimeslots();
        });
      }

      var eabObserver = new MutationObserver(queueNormalizeEabTimeslots);
      eabObserver.observe(document.body, { childList: true, subtree: true });
      normalizeEabTimeslots();

      var eabRunAttempts = 0;
      function requestEabRender() {
        if (document.querySelector('.servicify-select-a-time-button')) {
          normalizeEabTimeslots();
          return true;
        }
        if (!window.Servicify || typeof window.Servicify.run !== 'function') {
          return false;
        }
        var productId = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product
          ? window.ShopifyAnalytics.meta.product.id
          : null;
        var variantInput = document.querySelector('.d-buy__form input[name="id"], .d-buy__form select[name="id"]');
        var variantId = variantInput ? variantInput.value : null;
        if (!productId || !variantId) return false;
        try {
          window.Servicify.run({ productId: productId, variantId: variantId, parentElement: document });
        } catch (error) {
          return false;
        }
        return false;
      }

      var eabRunTimer = window.setInterval(function(){
        eabRunAttempts += 1;
        if (requestEabRender() || eabRunAttempts >= 20) {
          window.clearInterval(eabRunTimer);
        }
      }, 500);
      window.addEventListener('load', requestEabRender);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rental-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-ln-rental-booking]');
    if (!root) return;

    var apiBase = root.dataset.lnRentalApi || '/apps/ln-rental';
    var loginUrl = root.dataset.lnRentalLogin || '/account/login';
    var calendarEl = root.querySelector('[data-rental-calendar]');
    var monthEl = root.querySelector('[data-rental-month]');
    var requestEl = root.querySelector('[data-rental-root]');
    var completeEl = root.querySelector('[data-rental-complete]');
    var form = root.querySelector('[data-rental-form]');
    var statusEl = root.querySelector('[data-rental-status]');
    var defaultStatus = statusEl ? statusEl.textContent : '';
    var storageKey = 'lnRentalBookingState';
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var plans = {
      one_day: { label: '1日利用', days: 1, weekdayPrice: 33000, weekendHolidayPrice: 44000 },
      three_days: { label: '3日間プラン', days: 3, price: 110000 },
      five_days: { label: '特別5日間プラン', days: 5, price: 185000 },
      six_days: { label: '6日間プラン', days: 6, price: 200000 }
    };
    var rules = { setupPrice: 11000, extensionUnitPrice: 5500, maxExtensionUnits: 4 };
    var state = {
      month: new Date(today.getFullYear(), today.getMonth(), 1),
      startDate: '',
      lockedDates: [],
      holidayDates: [],
      plan: 'one_day',
      extensionUnits: 0,
      previousDaySetup: false,
      note: ''
    };

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function iso(date) {
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    }

    function addDays(value, amount) {
      var date = new Date(value + 'T00:00:00');
      date.setDate(date.getDate() + amount);
      return iso(date);
    }

    function isWeekend(value) {
      var day = new Date(value + 'T00:00:00').getDay();
      return day === 0 || day === 6;
    }

    function isHoliday(value) {
      return state.holidayDates.indexOf(value) !== -1;
    }

    function isWeekendOrHoliday(value) {
      return isWeekend(value) || isHoliday(value);
    }

    function formatYen(value) {
      return '¥' + Number(value || 0).toLocaleString('ja-JP');
    }

    function formatDateTime(value) {
      if (!value) return '-';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    function selectedPlan() {
      return plans[state.plan] || plans.one_day;
    }

    function targetDates() {
      if (!state.startDate) return [];
      var dates = [];
      if (state.previousDaySetup) dates.push(addDays(state.startDate, -1));
      var plan = selectedPlan();
      for (var index = 0; index < plan.days; index += 1) {
        dates.push(addDays(state.startDate, index));
      }
      return dates;
    }

    function calculate() {
      var plan = selectedPlan();
      var base = state.plan === 'one_day'
        ? (state.startDate && isWeekendOrHoliday(state.startDate) ? plan.weekendHolidayPrice : plan.weekdayPrice)
        : plan.price;
      return base + (state.previousDaySetup ? rules.setupPrice : 0) + (Number(state.extensionUnits) * rules.extensionUnitPrice);
    }

    function setStatus(message, type) {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.classList.toggle('is-error', type === 'error');
      statusEl.classList.toggle('is-success', type === 'success');
    }

    function setCompleteValue(selector, value) {
      if (!completeEl) return;
      var element = completeEl.querySelector(selector);
      if (element) element.textContent = value || '-';
    }

    function resetBookingState() {
      sessionStorage.removeItem(storageKey);
      state.startDate = '';
      state.plan = 'one_day';
      state.extensionUnits = 0;
      state.previousDaySetup = false;
      state.note = '';
      writeForm();
      renderCalendar();
      renderSummary();
    }

    function showComplete(data) {
      if (!completeEl || !requestEl) return;
      var quote = data.quote || {};
      requestEl.hidden = true;
      completeEl.hidden = false;
      setCompleteValue('[data-rental-complete-id]', data.reservationId);
      setCompleteValue('[data-rental-complete-dates]', (quote.targetDates || []).join(' / '));
      setCompleteValue('[data-rental-complete-total]', quote.amountText || formatYen(quote.amountYen));
      setCompleteValue('[data-rental-complete-expires]', formatDateTime(data.expiresAt));
      window.history.replaceState(null, '', '#booking-complete');
      completeEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function resetComplete() {
      if (!completeEl || !requestEl) return;
      completeEl.hidden = true;
      requestEl.hidden = false;
      resetBookingState();
      setStatus(defaultStatus, '');
      window.history.replaceState(null, '', '#booking');
      loadAvailability();
      requestEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function readForm() {
      var planInput = form.querySelector('input[name="plan"]:checked');
      state.plan = planInput ? planInput.value : 'one_day';
      state.extensionUnits = Number(form.elements.extensionUnits.value || 0);
      state.previousDaySetup = form.elements.previousDaySetup.checked;
      state.note = form.elements.note.value || '';
      var startInput = root.querySelector('[data-rental-start]');
      if (startInput) startInput.value = state.startDate;
    }

    function writeForm() {
      var planInput = form.querySelector('input[name="plan"][value="' + state.plan + '"]');
      if (planInput) planInput.checked = true;
      form.elements.extensionUnits.value = String(state.extensionUnits || 0);
      form.elements.previousDaySetup.checked = Boolean(state.previousDaySetup);
      form.elements.note.value = state.note || '';
    }

    function renderSummary() {
      readForm();
      var dates = targetDates();
      root.querySelector('[data-rental-total]').textContent = formatYen(calculate());
      root.querySelector('[data-rental-summary-start]').textContent = state.startDate || '未選択';
      root.querySelector('[data-rental-summary-dates]').textContent = dates.length ? dates.join(' / ') : '日付を選択してください';
      root.querySelector('[data-rental-summary-time]').textContent = state.extensionUnits
        ? '11:00-' + ['19:00', '19:30', '20:00', '20:30', '21:00'][state.extensionUnits]
        : '11:00-19:00';
      root.querySelector('[data-rental-summary-setup]').textContent = state.previousDaySetup ? 'あり (+¥11,000)' : 'なし';
    }

    function renderCalendar() {
      var year = state.month.getFullYear();
      var month = state.month.getMonth();
      monthEl.textContent = year + ' / ' + pad(month + 1);
      calendarEl.innerHTML = '';

      var first = new Date(year, month, 1);
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      for (var blank = 0; blank < first.getDay(); blank += 1) {
        var span = document.createElement('span');
        span.className = 'is-muted';
        calendarEl.appendChild(span);
      }
      for (var day = 1; day <= daysInMonth; day += 1) {
        var date = new Date(year, month, day);
        var dateIso = iso(date);
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(day);
        button.dataset.date = dateIso;
        if (date < today) button.classList.add('is-muted');
        if (isWeekend(dateIso)) button.classList.add('is-weekend');
        if (isHoliday(dateIso)) button.classList.add('is-holiday');
        if (state.lockedDates.indexOf(dateIso) !== -1) {
          button.classList.add('is-locked');
          button.disabled = true;
        }
        if (state.startDate === dateIso) button.classList.add('is-selected');
        button.addEventListener('click', function(event){
          state.startDate = event.currentTarget.dataset.date;
          persist();
          renderCalendar();
          renderSummary();
        });
        calendarEl.appendChild(button);
      }
    }

    function monthKey() {
      return state.month.getFullYear() + '-' + pad(state.month.getMonth() + 1);
    }

    function loadAvailability() {
      fetch(apiBase + '/availability?month=' + encodeURIComponent(monthKey()), { credentials: 'same-origin' })
        .then(function(response){ return response.ok ? response.json() : Promise.reject(response); })
        .then(function(data){
          state.lockedDates = data.lockedDates || [];
          state.holidayDates = (data.holidays || []).map(function(item){ return item.day; });
          renderCalendar();
          renderSummary();
        })
        .catch(function(){
          state.lockedDates = [];
          state.holidayDates = [];
          renderCalendar();
          renderSummary();
          setStatus('空き状況の自動確認は未接続です。日程は申請時に確認します。', 'error');
        });
    }

    function persist() {
      readForm();
      sessionStorage.setItem(storageKey, JSON.stringify({
        startDate: state.startDate,
        plan: state.plan,
        extensionUnits: state.extensionUnits,
        previousDaySetup: state.previousDaySetup,
        note: state.note
      }));
    }

    function restore() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        if (saved.startDate) state.startDate = saved.startDate;
        if (saved.plan && plans[saved.plan]) state.plan = saved.plan;
        state.extensionUnits = Number(saved.extensionUnits || 0);
        state.previousDaySetup = saved.previousDaySetup === true;
        state.note = saved.note || '';
      } catch (error) {
        sessionStorage.removeItem(storageKey);
      }
      writeForm();
    }

    root.querySelector('[data-rental-prev]').addEventListener('click', function(){
      state.month.setMonth(state.month.getMonth() - 1);
      loadAvailability();
    });
    root.querySelector('[data-rental-next]').addEventListener('click', function(){
      state.month.setMonth(state.month.getMonth() + 1);
      loadAvailability();
    });
    form.addEventListener('change', function(){
      persist();
      renderCalendar();
      renderSummary();
    });
    form.addEventListener('input', function(){
      persist();
      renderSummary();
    });
    var newRequestButton = root.querySelector('[data-rental-new]');
    if (newRequestButton) {
      newRequestButton.addEventListener('click', resetComplete);
    }
    form.addEventListener('submit', function(event){
      event.preventDefault();
      readForm();
      if (!state.startDate) {
        setStatus('利用開始日を選択してください。', 'error');
        return;
      }
      persist();
      var submit = root.querySelector('[data-rental-submit]');
      submit.disabled = true;
      setStatus('日程の重複確認と請求メール作成を行っています。', '');
      fetch(apiBase + '/reservations', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          startDate: state.startDate,
          plan: state.plan,
          extensionUnits: state.extensionUnits,
          previousDaySetup: state.previousDaySetup,
          note: state.note
        })
      })
        .then(function(response){
          return response.text().then(function(text){
            var data = {};
            try {
              data = text ? JSON.parse(text) : {};
            } catch (error) {
              data = { error: 'non_json_response', body: text };
            }
            return { response: response, data: data };
          });
        })
        .then(function(result){
          if (result.response.status === 401 || result.data.error === 'login_required' || result.response.url.indexOf('/account/login') !== -1) {
            window.location.href = result.data.loginUrl || loginUrl;
            return;
          }
          if (result.response.status === 409) {
            setStatus('選択日程の一部が先に押さえられました。別の日程を選択してください。重複日: ' + (result.data.conflictDates || []).join(' / '), 'error');
            loadAvailability();
            return;
          }
          if (!result.response.ok) {
            if (result.data.error === 'customer_lookup_failed') {
              setStatus('ログイン中のアカウント情報を確認できませんでした。ログアウト後、再度ログインしてお試しください。', 'error');
              return;
            }
            if (result.data.error === 'invoice_failed') {
              setStatus('日程確認は完了しましたが、請求メールを作成できませんでした。お手数ですがCONTACTよりお問い合わせください。', 'error');
              return;
            }
            setStatus('申請を完了できませんでした。時間を置いて再度お試しください。', 'error');
            return;
          }
          sessionStorage.removeItem(storageKey);
          setStatus('日程を24時間仮押さえしました。Shopifyの請求メールを送信しました。メールをご確認ください。', 'success');
          showComplete(result.data);
          resetBookingState();
          loadAvailability();
        })
        .catch(function(){
          setStatus('通信に失敗しました。ページを再読み込みしてから再度お試しください。', 'error');
        })
        .finally(function(){
          submit.disabled = false;
        });
    });

    restore();
    loadAvailability();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specimens-grid"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('.specimens');
    if (!root) return;
    var filtersTop = document.getElementById('filtersTop');
    var filtersSub = document.getElementById('filtersSub');
    var filterBlock = document.getElementById('filterBlock');
    var grid = document.getElementById('specGrid');
    if (!filtersTop || !grid) return;
    var isHome = root.classList.contains('specimens--home');
    var tabLimit = parseInt(root.dataset.tabLimit || '0', 10);
    var defaultTab = root.dataset.defaultTab || 'green';
    var tabFooter = root.querySelector('[data-tab-footer]');
    var tabStatus = root.querySelector('[data-tab-status]');
    var tabPagination = root.querySelector('[data-tab-pagination]');
    var viewTabLink = root.querySelector('[data-view-tab]');
    var shopUrl = viewTabLink ? viewTabLink.getAttribute('href') : '/collections/all';
    var activePages = {};
    var transitionTimer = null;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function installImageFallbacks() {
      Array.from(grid.querySelectorAll('.g-card .frame')).forEach(function(frame){
        var imgs = Array.from(frame.querySelectorAll('img'));
        if (!imgs.length) return;
        function showFallback(img) {
          img.hidden = true;
          if (imgs.every(function(item){ return item.hidden || (item.complete && item.naturalWidth === 0); }) && !frame.querySelector('.no-image')) {
            var fallback = document.createElement('div');
            fallback.className = 'no-image';
            fallback.innerHTML = '<span>NO IMAGE</span>';
            frame.insertBefore(fallback, frame.firstChild);
          }
        }
        imgs.forEach(function(img){
          img.addEventListener('error', function(){ showFallback(img); });
          if (img.complete && img.naturalWidth === 0) showFallback(img);
        });
      });
    }
    installImageFallbacks();
    window.setTimeout(installImageFallbacks, 600);
    window.setTimeout(installImageFallbacks, 1800);

    var SUBS = {
      green:  [ {k:'all',label:'ALL'}, {k:'caudex',label:'CAUDEX · 塊根'}, {k:'cactus',label:'CACTUS · サボテン'}, {k:'succulent',label:'SUCCULENT · 多肉'}, {k:'foliage',label:'FOLIAGE · 観葉'} ],
      rug:    [ {k:'all',label:'ALL'}, {k:'mini',label:'MINI'}, {k:'standard',label:'STANDARD'} ],
      object: [ {k:'all',label:'ALL'}, {k:'vessel',label:'VESSEL · 器'}, {k:'object',label:'OBJECT · オブジェ'}, {k:'frame',label:'FRAME · 木フレーム'} ]
    };

    var layoutKey = 'ln_layout_v1';
    var saved = localStorage.getItem(layoutKey);
    if (saved === 'large' || saved === 'medium') {
      root.setAttribute('data-layout', saved);
    } else if (saved === 'compact') {
      localStorage.setItem(layoutKey, 'medium');
      root.setAttribute('data-layout', 'medium');
    }

    var activeTop = 'all';
    var activeSub = 'all';
    var initialCategory = new URLSearchParams(window.location.search).get('category');
    if (initialCategory) {
      activeTop = initialCategory.toLowerCase();
    } else if (isHome && defaultTab) {
      activeTop = defaultTab;
    }

    function activeKey() {
      return activeTop + ':' + activeSub;
    }

    function resetActivePage() {
      if (!isHome || !tabLimit) return;
      activePages[activeKey()] = 1;
    }

    function currentPage() {
      if (!isHome || !tabLimit) return 1;
      if (!activePages[activeKey()]) activePages[activeKey()] = 1;
      return activePages[activeKey()];
    }

    // Compute counts from rendered cards and populate chips
    function updateCounts() {
      var counts = { all: 0, green: 0, pot: 0, rug: 0, object: 0, frame: 0 };
      Array.from(grid.children).forEach(function(card){
        if (!card.classList.contains('g-card')) return;
        var t = card.dataset.top;
        counts.all++;
        if (counts.hasOwnProperty(t)) counts[t]++;
      });
      Array.from(filtersTop.querySelectorAll('.chip')).forEach(function(c){
        var k = c.dataset.top;
        var n = counts[k] || 0;
        var span = c.querySelector('[data-count]');
        if (span) span.textContent = n;
        if (k !== 'all') c.classList.toggle('disabled', n === 0);
        if (k === 'frame') c.hidden = n === 0;
      });
      var totEl = root.querySelector('[data-total-count]');
      if (totEl) totEl.textContent = counts.all;
    }
    updateCounts();

    function scrollToProductTop() {
      if (!isHome) return;
      var header = document.getElementById('siteHeader');
      var offset = header ? header.offsetHeight + 12 : 0;
      var target = filterBlock || root;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }

    function applyFilter(options) {
      options = options || {};
      window.clearTimeout(transitionTimer);
      if (options.scroll) scrollToProductTop();
      if (options.animate && isHome && !prefersReducedMotion) {
        grid.classList.add('is-transitioning');
        transitionTimer = window.setTimeout(function(){
          renderFilter();
          grid.classList.remove('is-transitioning');
        }, 180);
        return;
      }
      grid.classList.remove('is-transitioning');
      renderFilter();
    }

    function renderFilter() {
      var cards = Array.from(grid.children).filter(function(card){
        return card.classList && card.classList.contains('g-card');
      });
      var matchedCards = [];
      cards.forEach(function(card){
        if (card.classList.contains('spec-empty')) return;
        var ct = card.dataset.top;
        var cs = (card.dataset.subs || '').split(/\s+/);
        var show = true;
        if (activeTop !== 'all') {
          if (activeTop === 'object') {
            show = (ct === 'object' || ct === 'frame');
          } else {
            show = (ct === activeTop);
          }
          if (show && activeSub !== 'all') show = cs.indexOf(activeSub) !== -1;
        }
        if (show) matchedCards.push(card);
      });

      var matched = matchedCards.length;
      var pageSize = isHome && tabLimit ? tabLimit : matched;
      var totalPages = pageSize ? Math.max(1, Math.ceil(matched / pageSize)) : 1;
      var page = currentPage();
      if (page > totalPages) {
        page = totalPages;
        activePages[activeKey()] = page;
      }
      var start = isHome ? (page - 1) * pageSize : 0;
      var end = isHome ? start + pageSize : matched;
      var shown = 0;
      cards.forEach(function(card){
        var matchIndex = matchedCards.indexOf(card);
        var show = matchIndex >= start && matchIndex < end;
        card.classList.toggle('hidden', !show);
        if (show) shown += 1;
      });
      updateTabFooter(matched, shown, page, totalPages, start);
      document.dispatchEvent(new CustomEvent('ln:content-update', { detail: { root: grid } }));
    }

    function updateTabFooter(matched, shown, page, totalPages, start) {
      if (!isHome || !tabFooter || !tabStatus) return;
      tabFooter.hidden = matched === 0;
      var rangeStart = matched ? start + 1 : 0;
      var rangeEnd = matched ? start + shown : 0;
      tabStatus.textContent = rangeStart + '-' + rangeEnd + ' / ' + matched + ' shown';
      renderPagination(page, totalPages);
      if (viewTabLink) {
        var href = shopUrl;
        if (activeTop !== 'all') href += '?category=' + encodeURIComponent(activeTop);
        viewTabLink.href = href;
      }
    }

    function renderPagination(page, totalPages) {
      if (!tabPagination) return;
      if (totalPages <= 1) {
        tabPagination.hidden = true;
        tabPagination.innerHTML = '';
        return;
      }
      tabPagination.hidden = false;
      var html = '<button type="button" data-page="' + (page - 1) + '"' + (page <= 1 ? ' disabled' : '') + '>PREV</button>';
      for (var i = 1; i <= totalPages; i += 1) {
        html += '<button type="button" data-page="' + i + '"' + (i === page ? ' class="is-active" aria-current="page"' : '') + '>' + i + '</button>';
      }
      html += '<button type="button" data-page="' + (page + 1) + '"' + (page >= totalPages ? ' disabled' : '') + '>NEXT</button>';
      tabPagination.innerHTML = html;
    }

    if (initialCategory || (isHome && defaultTab)) {
      Array.from(filtersTop.querySelectorAll('.chip')).forEach(function(c){ c.classList.toggle('active', c.dataset.top === activeTop); });
      applyFilter();
      if (SUBS[activeTop]) showSubs(activeTop);
    } else if (isHome) {
      applyFilter();
    }

    // top chip click
    filtersTop.addEventListener('click', function(e){
      var b = e.target.closest('.chip');
      if (!b || b.classList.contains('disabled')) return;
      activeTop = b.dataset.top;
      activeSub = 'all';
      resetActivePage();
      Array.from(filtersTop.querySelectorAll('.chip')).forEach(function(c){ c.classList.toggle('active', c.dataset.top === activeTop); });
      applyFilter({ animate: true, scroll: true });
      if (SUBS[activeTop]) {
        showSubs(activeTop);
      } else {
        hideSubs();
      }
    });

    // top chip hover → reveal subs
    filtersTop.addEventListener('mouseover', function(e){
      var b = e.target.closest('.chip');
      if (!b || b.classList.contains('disabled')) return;
      showSubs(b.dataset.top);
    });
    filterBlock.addEventListener('mouseleave', hideSubs);

    function showSubs(topKey){
      var subs = SUBS[topKey];
      if (!subs) { hideSubs(); return; }
      filtersSub.innerHTML = subs.map(function(s, i){
        var chip = '<button class="chip' + (topKey === activeTop && s.k === activeSub ? ' active' : '') + '" data-top="' + topKey + '" data-sub="' + s.k + '">' + s.label + '</button>';
        return i === 0 ? chip : '<span class="divider">/</span>' + chip;
      }).join('');
      filtersSub.classList.add('open');
    }
    function hideSubs(){ filtersSub.classList.remove('open'); }

    // sub chip click (delegate)
    document.addEventListener('click', function(e){
      var b = e.target.closest('#filtersSub .chip');
      if (!b || b.classList.contains('disabled')) return;
      activeTop = b.dataset.top;
      activeSub = b.dataset.sub;
      resetActivePage();
      Array.from(filtersTop.querySelectorAll('.chip')).forEach(function(c){ c.classList.toggle('active', c.dataset.top === activeTop); });
      applyFilter({ animate: true, scroll: true });
      showSubs(activeTop);
    });

    if (tabPagination) {
      tabPagination.addEventListener('click', function(e){
        var button = e.target.closest('button[data-page]');
        if (!button || button.disabled) return;
        var page = parseInt(button.dataset.page || '1', 10);
        activePages[activeKey()] = Math.max(1, page);
        applyFilter({ animate: true, scroll: true });
      });
    }

    // layout switcher
    var switchGroup = root.querySelector('.spec-layout-switch');
    if (switchGroup) {
      switchGroup.addEventListener('click', function(e){
        var b = e.target.closest('button');
        if (!b) return;
        var key = b.dataset.layout;
        root.setAttribute('data-layout', key);
        localStorage.setItem(layoutKey, key);
        Array.from(switchGroup.children).forEach(function(c){ c.classList.toggle('active', c.dataset.layout === key); });
      });
      // sync initial active
      Array.from(switchGroup.children).forEach(function(c){ c.classList.toggle('active', c.dataset.layout === root.getAttribute('data-layout')); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
